import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _partial from 'lodash/partial'
import { connect } from 'react-redux'
import { Map, List } from 'immutable'
import {
  historyRedirect,
  HISTORY_METHOD_REPLACE,
} from '../../services/navigation/index'
import Tile from '../Tile/index'
import { TYPE_NEXT_VIDEO } from '../../services/tiles/index'
import { STORE_KEY_VIDEO_PLAYER_NEXT } from '../../services/store-keys/index'
import { createWatchUrl } from '../Watch/index'
import { getBoundActions } from '../../actions/index'
import {
  TYPE_CONTENT_VIDEO_YOGA,
  TYPE_CONTENT_VIDEO_FITNESS,
  TYPE_CONTENT_VIDEO_MEDITATION,
  TYPE_CONTENT_EPISODE_YOGA,
  TYPE_CONTENT_EPISODE_FITNESS,
  TYPE_CONTENT_EPISODE_MEDITATION,
  TYPE_CONTENT_SEGMENT_YOGA,
  TYPE_CONTENT_SEGMENT_FITNESS,
  TYPE_CONTENT_SEGMENT_MEDITATION,
  TYPE_CONTENT_EPISODE_GUIDE,
  SUBTYPE_CONTENT_YOGA,
  SUBTYPE_CONTENT_MEDITATION,
  SUBTYPE_CONTENT_FITNESS,
} from '../../services/content-type/index'
import {
  createUpstreamContext,
  SCREEN_TYPE_VIDEO_PLAYER,
  CONTEXT_TYPE_VIDEO_END_STATE,
} from '../../services/upstream-context/index'
import ButtonToggle from '../ButtonToggle/index'
import { isLiveAccessFeature } from '../../services/live-access-feature/index'
import Button, { TYPES } from '../Button/index'
import {
  AUTOPLAY_TOGGLED_GA4_EVENT,
  PLAY_CLICK_GA4_EVENT,
} from '../../services/event-tracking/index'
import { hasLiveAccessEntitlement } from '../../services/subscription/index'
import { URL_GAIA_PLUS } from '../../services/url/constants'

function shouldAutoPlay (props) {
  const { previousVideo = Map() } = props
  const contentType = previousVideo.getIn(['type', 'content'])
  const contentSubtype = previousVideo.get('contentSubtype')
  // Set the timer except for yoga, fitness and meditation
  switch (contentType) {
    case TYPE_CONTENT_VIDEO_YOGA:
    case TYPE_CONTENT_VIDEO_FITNESS:
    case TYPE_CONTENT_VIDEO_MEDITATION:
    case TYPE_CONTENT_EPISODE_YOGA:
    case TYPE_CONTENT_EPISODE_FITNESS:
    case TYPE_CONTENT_EPISODE_MEDITATION:
    case TYPE_CONTENT_SEGMENT_YOGA:
    case TYPE_CONTENT_SEGMENT_FITNESS:
    case TYPE_CONTENT_SEGMENT_MEDITATION:
      return false
    case TYPE_CONTENT_EPISODE_GUIDE:
      return contentSubtype !== SUBTYPE_CONTENT_YOGA
        && contentSubtype !== SUBTYPE_CONTENT_MEDITATION
        && contentSubtype !== SUBTYPE_CONTENT_FITNESS
    default:
      return true
  }
}

function getTilesState (storeKey, props) {
  return props.tiles.get(storeKey, Map())
}

function renderTile (props) {
  const { auth, tileData } = props
  return (
    <Tile
      auth={auth}
      tileData={tileData}
      tileClass="video-player-up-next__tile"
      showMoreInfo={false}
      single
      onClickWatch={_partial(onClickWatch, _partial.placeholder, props)}
      uiLocation="End Screen"
    />
  )
}

function onAutoPlaySettingsChange (props) {
  const { disableAutoPlayNext, setFeatureTrackingDataPersistent } = props
  setFeatureTrackingDataPersistent({
    data: Map({ disableAutoPlayNext: !disableAutoPlayNext }),
  })
}

function renderTimerText (state, props) {
  const { isLiveAccessUpgradeToWatch } = props
  const {
    staticText, disableAutoPlayNext, staticTextOn, staticTextOff,
  } = props

  const eventDataGA4 = AUTOPLAY_TOGGLED_GA4_EVENT
    .mergeDeep({
      ui_location: 'End Screen',
      changed_to: !disableAutoPlayNext ? 'off' : 'on',
    })

  const labelAutoplay = staticText.getIn(['data', 'autoplay'])
  const labelOn = `${labelAutoplay} ${staticTextOn}`
  const labelOff = `${labelAutoplay} ${staticTextOff}`

  if (isLiveAccessUpgradeToWatch) {
    return (
      <div className="video-player-up-next__timer">
        <div className="video-player-up-next__timer-text-autoplay">
          <span className="video-player-up-next__timer-text">
            {staticText.getIn(['data', 'upNext'])}:
          </span>
        </div>
      </div>
    )
  }

  if (shouldAutoPlay(props)) {
    return (
      <div className="video-player-up-next__timer">
        {props.enableTimer && (
          <div className="video-player-up-next__timer-text-autoplay">
            { disableAutoPlayNext
              ? <span className="video-player-up-next__timer-text">
                {staticText.getIn(['data', 'recommended_next'])}
              </span>
              : <span className="video-player-up-next__timer-text--large">
                {`${staticText.getIn(['data', 'upNext'])} ${staticText.getIn(['data', 'in'])} ${state.seconds} ${staticText.getIn(['data', 'sec'])}`}
              </span>
            }
            <span>
              <ButtonToggle
                onChange={() => onAutoPlaySettingsChange(props)}
                checked={!disableAutoPlayNext}
                ga4EventData={eventDataGA4}
                showLabel
                labelTextOn={labelOn}
                labelTextOff={labelOff}
                round
                small
              />
            </span>
          </div>
        )}
      </div>
    )
  }
  return (
    <div className="video-player-up-next__timer video-player-up-next__timer-text-autoplay">
      <span className="video-player-up-next__timer-text">
        {staticText.getIn(['data', 'recommended_next'])}
      </span>
    </div>
  )
}

function onClickWatch (e, props) {
  gotoNextVideo(props)
}

function fireNextVideoEvent (options) {
  const { props, timer, nextVideoId } = options
  const {
    id,
    setUpstreamContext,
  } = props

  const updatedContext = createUpstreamContext({
    screenType: SCREEN_TYPE_VIDEO_PLAYER,
    contextType: CONTEXT_TYPE_VIDEO_END_STATE,
    nextVideoId,
    videoId: id,
    autoplay: !!timer,
  })

  setUpstreamContext(updatedContext)
}

function gotoNextVideo (props, timer) {
  const {
    location, history, auth, language, setEventDefault,
  } = props
  const { pathname } = location
  const tilesState = getTilesState(STORE_KEY_VIDEO_PLAYER_NEXT, props)
  const tileData = tilesState.getIn(['data', 'titles', 0], Map())
  const url = tileData.get('url')
  const nextVideoId = tileData.get('id')
  const seriesId = tileData.get('seriesId')
  // If you can watch, go the next video, otherwise go to the next video detail page
  // if there is no next video url, go back to the just watched video detai page
  fireNextVideoEvent({ props, timer, nextVideoId })
  if (!url) {
    historyRedirect({
      history, url: pathname, auth, language,
    })
    return
  }
  const watchUrl = createWatchUrl(
    auth,
    tileData.get('feature', Map()),
    tileData.get('preview', Map()),
    url,
  )

  // GA4 event
  let ga4EventData = {
    content_id: nextVideoId,
    content_type: tileData.get('contentType'),
    content_name: tileData.get('title'),
    media_id: tileData.getIn(['feature', 'id']),
    media_language: tileData.get('mediaLanguage'),
    is_featured_media: true,
    ui_element: timer ? 'Autoplay' : 'Tile',
    ui_location: 'End Screen',
  }

  if (seriesId) {
    ga4EventData = {
      ...ga4EventData,
      parent_series_name: tileData.get('seriesTitle'),
      parent_series_id: seriesId,
    }
  }

  setEventDefault(PLAY_CLICK_GA4_EVENT.mergeDeep(ga4EventData))

  historyRedirect({
    history,
    url: watchUrl,
    auth,
    language,
    historyMethod: HISTORY_METHOD_REPLACE,
  })
}

class VideoPlayerUpNext extends Component {
  constructor (props) {
    super(props)
    this.state = {
      seconds: 15,
    }
  }

  componentDidMount () {
    const { props } = this
    const {
      auth, id, location, getTilesData, user = Map(), primaryCourse,
    } = props

    if (process.env.BROWSER) {
      const tilesState = getTilesState(STORE_KEY_VIDEO_PLAYER_NEXT, props)
      const language = (user.getIn(['data', 'language'], List()) || List()
      ).toJS()
      const tilesOptions = { type: TYPE_NEXT_VIDEO, language }

      if (primaryCourse && Map.isMap(primaryCourse)) {
        tilesOptions.courseContentId = primaryCourse.get('contentId')
      }

      if (!tilesState.get('processing') && !tilesState.get('data')) {
        getTilesData(
          STORE_KEY_VIDEO_PLAYER_NEXT,
          id,
          Map(tilesOptions),
          0,
          1,
          null,
          location,
          auth.get('uid'),
          auth.get('jwt'),
        )
      }
    }
  }

  componentDidUpdate () {
    if (process.env.BROWSER) {
      const { props: nextProps } = this
      const tilesState = getTilesState(STORE_KEY_VIDEO_PLAYER_NEXT, nextProps)
      if (
        !this._setUpNextInterval
        && !tilesState.get('processing')
        && tilesState.get('data')
      ) {
        if (!nextProps.isLiveAccessUpgradeToWatch && shouldAutoPlay(nextProps)) {
          this.setTimer()
        }
      }
      if (!nextProps.enableTimer) {
        clearInterval(this._setUpNextInterval)
      }
    }
    return undefined
  }

  componentWillUnmount () {
    if (this._setUpNextInterval) {
      clearInterval(this._setUpNextInterval)
    }
    this.props.deleteTiles(STORE_KEY_VIDEO_PLAYER_NEXT)
    this.props.setVideoPlayerEnded(false)
  }

  setTimer = () => {
    this._setUpNextInterval = setInterval(this.listener, 1000)
  }

  listener = () => {
    const { disableAutoPlayNext } = this.props
    this.setState(({ seconds }) => {
      if (seconds > 0) {
        return { seconds: seconds - 1 }
      }
      clearInterval(this._setUpNextInterval)
      if (!disableAutoPlayNext) {
        gotoNextVideo(this.props, 'timer')
      }
      return {}
    })
  }

  render () {
    const { props } = this
    const { state } = this
    if (!props.tileData) return null

    return (
      <div className="video-player-up-next">
        {renderTimerText(state, props)}
        {renderTile(props)}
        {
          props.isLiveAccessUpgradeToWatch
          && <Button
            type={TYPES.PRIMARY}
            url={URL_GAIA_PLUS}
          >
            {props.staticText.getIn(['data', 'learnAboutEventsPlus'])}
          </Button>
        }
      </div>
    )
  }
}

VideoPlayerUpNext.propTypes = {
  auth: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  tiles: ImmutablePropTypes.map.isRequired,
  getTilesData: PropTypes.func.isRequired,
  deleteTiles: PropTypes.func.isRequired,
  setVideoPlayerEnded: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  enableTimer: PropTypes.bool.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  clearUpstreamContext: PropTypes.func.isRequired,
  isLiveAccessUpgradeToWatch: PropTypes.bool,
  tileData: ImmutablePropTypes.map,
  setEventDefault: PropTypes.func.isRequired,
  primaryCourse: ImmutablePropTypes.map,
}

export default connect(
  (state) => {
    const subscriptions = state.auth.get('subscriptions', List())
    const tilesState = state.tiles.get(STORE_KEY_VIDEO_PLAYER_NEXT, Map())
    let isLiveAccessUpgradeToWatch = false
    let tileData = null

    if (tilesState) tileData = tilesState.getIn(['data', 'titles', 0], null)

    if (tileData) {
      isLiveAccessUpgradeToWatch = isLiveAccessFeature(tileData.get('feature', Map()))
        && !hasLiveAccessEntitlement(subscriptions)
    }

    return ({
      staticText: state.staticText.getIn(['data', 'videoPlayerUpNext']),
      staticTextOn: state.staticText.getIn(['data', 'buttonToggle', 'data', 'labelOn']),
      staticTextOff: state.staticText.getIn(['data', 'buttonToggle', 'data', 'labelOff']),
      auth: state.auth,
      user: state.user,
      language: state.user.getIn(['data', 'language']),
      app: state.app,
      page: state.page,
      video: state.video,
      disableAutoPlayNext: state.featureTracking.getIn(['data', 'disableAutoPlayNext'], false),
      isLiveAccessUpgradeToWatch,
      tileData,
      upstreamContext: state.upstreamContext,
    })
  },
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      clearUpstreamContext: actions.upstreamContext.clearUpstreamContext,
      setUpstreamContext: actions.upstreamContext.setUpstreamContext,
      setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
      setEventDefault: actions.eventTracking.setEventDefault,
    }
  },
)(VideoPlayerUpNext)
